import { SnackbarProvider } from 'notistack';
import type { ReactNode } from 'react';

/**
 * The single global toast/snackbar system (docs/development/FrontendGuidelines.md §9.4). No feature
 * reimplements its own toast component — everything goes through `hooks/useToast.ts`, which wraps
 * notistack's `useSnackbar` with the app's four semantic variants.
 */
export function SnackbarAppProvider({ children }: { children: ReactNode }) {
  return (
    <SnackbarProvider
      maxSnack={3}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      {children}
    </SnackbarProvider>
  );
}
